import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import { FetchStatus } from 'data/core';
import { saveTasks } from 'data/tasks/slice';
import { getDocTasks } from '../../actions';
import { setTasksLoading } from '../../slice';

function* getDocTasksManager(
  action: PayloadAction<{
    documentId: number;
    projectId: number;
  }>,
) {
  const { payload } = action;

  yield put(setTasksLoading(true));
  try {
    const response = yield DocumentsAPI.getTasks(
      payload.projectId,
      payload.documentId,
    );

    yield put(saveTasks({ data: response, fetchStatus: FetchStatus.Loaded }));
    yield put(setTasksLoading(false));
  } catch {
    yield put(setTasksLoading(false));
  }
}
export const watchGetDocTasks = function* () {
  yield takeLatest(getDocTasks.type, getDocTasksManager);
};
